/* eslint-disable max-lines*/
import { Accordion, AccordionDetails, AccordionSummary, makeStyles } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import {
    createNewFormStructure,
    getSubjects
} from '../../../redux/DynamicForms/DynamicFormsAction';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import { getClinicId, getNamespace } from '../../../utils/storage';
import { AutosizeTextarea, ClinicInput, MainSelect, SubmitButton } from '../../UI';
import { DropDownIcon } from '../../UI/Images/Icons';
import { editForm } from '../../../redux/DynamicForms/DynamicFormsAction';

const styles = makeStyles({
    formContainer: {
        maxWidth: '545px',
        margin: '0 auto'
    },
    submitBtnContainer: (props) => ({
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'absolute',
        bottom: '17px',
        left: props.rtl ? '10px' : 'auto',
        right: props.rtl ? 'auto' : '10px',
        margin: '0 10px'
    }),
    accordionRoot: {
        boxShadow: 'none'
    },
    accordionSummary: {
        color: '#bec1c7',
        minHeight: '40px'
    },
    summaryContent: {
        margin: '0 !important',
        display: 'flex',
        alignItems: 'center'
    },
    accordionDetailsRoot: {
        flexFlow: 'column'
    },
    expanded: {
        minHeight: '40px',
        '& svg': {
            transform: 'rotate(180deg)'
        }
    }
});
const NewForm = ({ handleClose, isEdit = false, title, description, formName }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const [idAccordionIsExpanded, setIdAccordionExpanded] = useState(false);
    const subjects = useSelector((state) =>
        state.dynamicForms.subjects?.filter((item) => item === 'patient')
    );
    const allForms = useSelector((state) => state.dynamicForms.allForms);
    const maxOrder = allForms?.length ? Math.max(...allForms.map((item) => item.order)) + 0.01 : 0;

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getSubjects());
    }, []);
    return (
        <Formik
            enableReinitialize
            initialValues={
                isEdit
                    ? { title: title, description: description }
                    : {
                          title: '',
                          description: '',
                          id: '',
                          subject: subjects && subjects.length ? subjects[0] : null
                      }
            }
            validationSchema={Yup.object(
                isEdit
                    ? {
                          title: Yup.string().required(messages.validations.required)
                      }
                    : {
                          title: Yup.string().required(messages.validations.required),
                          subject: Yup.string().required(messages.validations.required)
                      }
            )}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                const form = {
                    namespace: getNamespace(),
                    subject_key: values.subject,
                    description: values.description ? values.description : undefined,
                    title: values.title,
                    suggested_handle: values.id ? values.id : undefined,
                    presentation: {},
                    order: maxOrder,
                    clinic: getClinicId()
                };

                const response = await dispatch(
                    isEdit ? editForm(formName, values) : createNewFormStructure(form)
                );
                setSubmitting(false);
                if (response?.status === 201 || response?.status === 200) {
                    handleClose();
                }
            }}
        >
            {({ isSubmitting, values }) => (
                <Form>
                    {isEdit ? (
                        <>
                            <div>
                                <ClinicInput
                                    name="title"
                                    label={messages.formTitle}
                                    type="text"
                                    dir="auto"
                                    autoFocus
                                    width="100%"
                                />
                            </div>
                            <div>
                                <AutosizeTextarea
                                    name="description"
                                    id="description"
                                    label={messages.formDescription}
                                    width={400}
                                    rows={1}
                                />
                            </div>
                            <div className={classes.submitBtnContainer}>
                                <SubmitButton
                                    data-testid="submitBtn"
                                    isSubmitting={isSubmitting}
                                    submitText={messages.saveChanges}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <ClinicInput
                                    name="title"
                                    label={messages.formTitle}
                                    type="text"
                                    dir="auto"
                                    autoFocus
                                    width="100%"
                                />
                            </div>
                            <div>
                                <MainSelect
                                    options={subjects}
                                    label={messages.formSubject}
                                    name="subject"
                                    value={values.subject}
                                />
                            </div>
                            <div>
                                <AutosizeTextarea
                                    name="description"
                                    label={messages.formDescription}
                                    width={400}
                                    rows={1}
                                />
                            </div>
                            <div>
                                <Accordion
                                    classes={{ root: classes.accordionRoot }}
                                    expanded={idAccordionIsExpanded}
                                    onChange={(e, expanded) => setIdAccordionExpanded(expanded)}
                                >
                                    <AccordionSummary
                                        classes={{
                                            root: classes.accordionSummary,
                                            content: classes.summaryContent,
                                            expanded: classes.expanded
                                        }}
                                    >
                                        {messages.complementaryFormInfo}
                                        <DropDownIcon fill="#bec1c7" />
                                    </AccordionSummary>
                                    <AccordionDetails
                                        classes={{ root: classes.accordionDetailsRoot }}
                                    >
                                        {/* <Typography>{messages.formUIDTip}</Typography> */}
                                        <div>
                                            <ClinicInput
                                                name="id"
                                                label={messages.formUID}
                                                type="text"
                                            />
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <div className={classes.submitBtnContainer}>
                                    <SubmitButton
                                        data-testid="submitBtn"
                                        isSubmitting={isSubmitting}
                                        submitText={messages.submit}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </Form>
            )}
        </Formik>
    );
};
NewForm.propTypes = {
    handleClose: PropTypes.func,
    isEdit: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    formName: PropTypes.string
};

export default NewForm;
